module.exports = __webpack_public_path__ + "img/top.a1d13060.png";